import { type ClassStatus } from '../../../../context/types';

export interface Instructor {
    user_name: string;
    email: string | null;
}

export interface InstructorWithEmail extends Instructor {
    email: string;
}

export interface ClassWithInstructors {
    class_name: string;
    class_uuid: string;
    class_id: number;
    meeting_id: string;
    starting_at?: string;
    ending_at?: string;
    status: ClassStatus;
    instructors: Instructor[];
}

interface Sender {
    name: string;
    role?: 'teacher' | 'student';
    zoom_id: string;
    initials: string;
    student_id?: number;
    is_verified: boolean;
    participant_id: string;
}

interface LegacySender {
    role: 'teacher' | 'student';
    zoom_id: number;
    userName: string;
    student_id: number;
    participant_id: string;
    meeting_zoom_id: string;
}

export interface LegacyChatRecordData {
    from?: LegacySender;
    text: string;
    uuid: string;
    where: {
        breakout_id?: string;
    };
    channel: string;
}

export interface ChatRecordData {
    from?: Sender;
    content: string;
    message_uuid: string;
    breakout_id?: string; // Name of the breakout room
}

export interface ChatHistoricalRecord {
    class_session_chat_id: number;
    class_id: number;
    class_session_uuid: string;
    type: string;
    student_id?: number | null;
    timestamp: number;
    data: ChatRecordData | LegacyChatRecordData;
    is_hidden: boolean;
}

export interface DownloadChatOptions {
    class_id: number;
    start_time?: number | null;
    end_time?: number | null;
    user_uuid?: string | null;
    class_uuid?: string | null;
}

export interface Option {
    label: string;
    email: string;
}

export enum DirectionOption {
    ASCENDING = 'asc',
    DESCENDING = 'desc'
}

export type Direction = undefined | DirectionOption;

export enum SortOption {
    NAME = 'NAME',
    INSTRUCTOR = 'INSTRUCTOR',
    DATES = 'DATES'
}

export enum TimeFilter {
    All = 'all',
    Current = 'current',
    Completed = 'completed'
}

export type SortBy = undefined | SortOption;
